import React from "react";
import asPage from "components/core/as-page";
import Breadcrumbs from "components/core/breadcrumbs";
import Header from "components/core/header";
import HeaderBanner from "components/core/header-banner";
import Layout from "components/core/layout";
import TextContent from "components/elements/text-content";

const TermsOfUse = () => (
  <Layout className="privacy-policy" title="Privacy policy">
    <Header>
      <HeaderBanner
        title="Privacy policy"
        icon="faq"
        background="/static/images/header-balcony.jpg"
      />
    </Header>
    <Breadcrumbs>
      <Breadcrumbs.Item title="Privacy policy" url="privacy-policy" />
    </Breadcrumbs>
    <div className="container">
      <TextContent>
        <p>
          “Hammer Price Homes Limited” or &quot;we&quot; or “our” are committed
          to protecting and respecting your privacy. We are registered with the
          Information Commissioner&apos;s Office under registration reference:
          ZA114873
        </p>

        <p>
          We fully support the General Data Protection Regulation (GDPR)
          effective from 25 May 2018 and we have reviewed and amended this, our
          privacy policy, and other working methods accordingly.
        </p>

        <p>
          This policy (together with our terms and conditions and any other
          documents referred to on it) sets out the basis on which any personal
          data we collect from you, or that you provide to us, will be processed
          by us. Please read the following carefully to understand our views and
          practices regarding your personal data and how we will treat it. By
          visiting our website &nbsp;<a href="/">www.hammerpricehomes.co.uk</a>,
          you are accepting and consenting to the practices described in this
          notice.
        </p>

        <h2>INFORMATION WE MAY COLLECT FROM YOU</h2>

        <p>We may collect and process the following data about you:</p>

        <ol>
          <li>
            <strong>Information you give us.</strong>
          </li>
        </ol>

        <p>
          This includes information you provide when you register to use our
          site. The information you give us will include your name, address,
          email address and phone number, date of birth and proof of I.D. If you
          give us information on behalf of someone else, you confirm that you
          have given them the information set out in this notice and that they
          have given permission for us to use their information as set out in
          this notice.
        </p>

        <ol start={2}>
          <li>
            <strong>Information we collect about you.</strong>
          </li>
        </ol>

        <p>
          With regard to each of your visits to our site we may automatically
          collect the following information:
        </p>

        <ul>
          <li>
            {" "}
            Technical information, including the Internet protocol (IP) address
            used to connect your computer to the Internet, your login
            information, browser type and version, time zone setting, browser
            plug-in types and versions, operating system and platform;
          </li>

          <li>
            {" "}
            Information about your visit, including the full Uniform Resource
            Locators (URL) clickstream to, through and from our site (including
            date and time); properties you viewed or searched for; page response
            times, download errors, length of visits to certain pages, page
            interaction information (such as scrolling, clicks, and
            mouse-overs), and methods used to browse away from the page and any
            phone number used to call our customer service number.
          </li>

          <li>
            {" "}
            Information we receive from other sources. We are also working
            closely with third parties (including, for example, business
            partners, advertising networks, analytics providers, search
            information providers and may receive information about you from
            them.
          </li>

          <li>
            {" "}
            Geo-Location Information. Some devices allow applications to access
            real-time location based information (for example GPS). Our mobile
            apps may collect such information from your mobile device at any
            time while you download or use our mobile apps. We may use this
            information to optimise your experience.
          </li>

          <li>
            {" "}
            Personal and Non-personal information. Personal information is
            information that can be used to uniquely identify a single person.
            We also collect non-personal information, or may anonymise personal
            information in order to make it non-personal. Non-personal
            information is information that will not allow a specific individual
            to be identified. You agree that Hammer Price Homes Limited may
            collect, store, use, transfer and disclose non-personal information
            for any purpose; for example, the use of aggregated transactional
            information for commercial purposes. Under this notice, information
            collected by cookies and similar technologies are dealt with as
            non-personal information.
          </li>
        </ul>

        <h2>USES MADE OF THE INFORMATION</h2>

        <p> We use information held about you in the following ways:</p>

        <ul>
          <li>
            {" "}
            to carry out our obligations arising from any contracts entered into
            between you and us and to provide you with the information and
            services that you request from us;
          </li>
          <li> to notify you about changes to our service;</li>
          <li>
            {" "}
            to understand customer requirements, perform analysis and
            comparisons and to obtain your views on our services and website(s);
          </li>
          <li> to develop and test our website and services;</li>
          <li>
            {" "}
            to improve our site and ensure that content from our site is
            presented in the most effective manner for you and for your
            computer;
          </li>
          <li>
            {" "}
            to administer our site and for internal operations, including
            troubleshooting, data analysis, testing, research, statistical and
            survey purposes;
          </li>
          <li>
            {" "}
            to allow you to participate in interactive features of our service,
            when you choose to do so; and
          </li>
          <li> to keep our site safe and secure;</li>
        </ul>

        <p>
          We may combine the information we receive from other sources with
          information you give to us and information we collect about you. We
          may us this information and the combined information for the purposes
          set out above (depending on the types of information we receive).
        </p>

        <h2>DISCLOSURE OF YOUR INFORMATION</h2>

        <p>
          {" "}
          We may share your personal information with selected third parties
          including:{" "}
        </p>

        <ul>
          <li>
            {" "}
            Business partners and conveyancing solicitors for the performance of
            any contract we enter into with them or you.
          </li>
          <li>
            {" "}
            Sellers of Property who host open days and who are entitled to
            receive a list of attendees including name, phone number and
            postcode. This will facilitate the checking of I.D by the seller at
            the Open days.
          </li>
          <li>
            {" "}
            Analytics and search engine providers that assist us in the
            improvement and optimisation of our site, although ordinarily only
            non-personal information is shared.
          </li>
        </ul>

        <p> We may disclose your personal information to third parties: </p>

        <ul>
          <li>
            {" "}
            In the event that we sell or buy any business or assets, in which
            case we may disclose your personal information to the prospective
            seller or buyer of such business or assets.
          </li>
          <li>
            If Hammer Price Homes Limited or substantially all of its assets are
            acquired by a third party, in which case personal information held
            by it about its customers will be one of the transferred assets.
          </li>
          <li>
            If we are under a duty to disclose or share your personal data in
            order to comply with any legal obligation, or otherwise permitted
            under law to do so, or in order to enforce or apply our terms of use
            and other agreements; or to protect the rights, property, or safety
            of Hammer Price Homes Limited, our customers, or others. This
            includes exchanging information with other companies and
            organisations for the purposes of fraud/crime protection and
            investigation and credit risk reduction.
          </li>
        </ul>

        <h2>HOW LONG DO WE KEEP YOUR INFORMATION FOR?</h2>
        <ul>
          <li>
            To make sure we meet our legal data protection and privacy
            obligations, we only hold on to your information for as long as we
            actually need it for the purposes we acquired it for in the first
            place.
          </li>
          <li>
            In most cases, this means we will keep your information for as long
            as you continue to use our services, and for a reasonable period of
            time afterwards if you stop doing so, to see if we can persuade you
            to come back to us. After that we will delete it other than where we
            lawfully can keep any data for audit or legal reasons.
          </li>
          <li>
            Our business is a used regularly by those who have used our services
            before. We will ask every 12 months that you update your details so
            that details we hold are accurate and that we are in compliance with
            Money Laundering regulations. Failure to update your details/confirm
            that details are correct at that time will prevent you from
            accessing the sites services.
          </li>
          <li>
            We shall keep data on our database for not longer than 3 years from
            your last recorded open day booking or bid subject to an
            individual’s right to have their account deleted at their request.
          </li>
          <li>
            After this time should you wish to register again then you can do so
            but will need to open up a new account as though registering for the
            first time.
          </li>
          <li>
            If you wish to have your account deleted then you should request
            this by email to &nbsp;
            <a href="mailto:enquiries@hammerpricehomes.co.uk">
              enquiries@hammerpricehomes.co.uk
            </a>
            .
          </li>
        </ul>

        <h2>DATA STORAGE &amp; SECURITY </h2>

        <p>
          The data that we collect from you is stored at a UK Tier 1 Data Host
          provider called UKFast.Net Limited (https://www.ukfast.co.uk/). UKFast
          hold the ISO 27018 accreditation.
        </p>
        <p>
          The data that we collect from you will be stored at a UK destination.
          This will be stored using the storage medium &amp; data centres
          belonging to our UK preferred supplier. By submitting your personal
          data, you agree to this method of storage. We will take all steps
          reasonably necessary to ensure that your data is treated securely and
          in accordance with this privacy policy. By submitting your personal
          data, you agree to this method of storage. We will take all steps
          reasonably necessary to ensure that your data is treated securely and
          in accordance with this privacy policy.
        </p>

        <p>
          Where we have given you (or where you have chosen) a password or
          access code which enables you to access certain parts of our site, you
          are responsible for keeping this password confidential. We ask you not
          to share a password with anyone, and you authorise Hammer Price Homes
          Limited to act upon instructions and information from any person that
          enters your user id or password.
        </p>

        <p>
          Unfortunately, the transmission of information via the internet is not
          completely secure. Although we will do our best to protect your
          personal data, we cannot guarantee the security of your data
          transmitted to our site; any transmission is at your own risk. Once we
          have received your information, we will use strict procedures and
          security features to try to prevent unauthorised access.
        </p>

        <h2>YOUR RIGHTS</h2>

        <p>
          Where applicable, you may have certain rights under the UK’s Data
          Protection Act 1998, including the right to see the personal
          information held about you and you may ask us to make any necessary
          changes to ensure it is accurate and up to date. If, where applicable,
          you would like a copy of the personal information we hold about you,
          please see the &nbsp;<a href="/contact/">Contact Us</a> section. There
          is a £10 fee. Where applicable, the Data Protection Act also provides
          the following rights in relation to personal information:
        </p>

        <ul>
          <li> Prevent processing where it may cause damage or distress;</li>
          <li>
            {" "}
            Commence Court action to claim compensation for damage or distress
            caused by our failure to comply with the Act;
          </li>
          <li> Object to automatic processing; and</li>
          <li> Prevent direct marketing.</li>
        </ul>

        <p>
          Our site may, from time to time, contain links to and from the
          websites of our partner networks, advertisers and affiliates. If you
          follow a link to any of these websites, please note that these
          websites have their own privacy policies and that we do not accept any
          responsibility or liability for these policies. Please check these
          policies before you submit any personal data to these websites.
        </p>

        <h2 id="cookie-policy">COOKIES</h2>

        <p>
          Our website uses “cookies” and other technologies, which store small
          amounts of information on your computer or device, to allow certain
          information from your web browser to be collected. Cookies are widely
          used on the internet and allow a website/portal to recognise a user’s
          device, without uniquely identifying the individual person using the
          computer. These technologies help to make it easier for you to log on
          and use the site, provide feedback to us as to which parts of the
          website you visit, so we can assess the effectiveness of the site and
          provide a better user experience or to serve Hammer Price Homes
          Limited adverts to you whilst browsing other sites.
        </p>
        <p>
          For more information about cookies, including how to see what cookies
          have been set and how to manage, block and delete them, see{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="http://www.allaboutcookies.org/"
          >
            www.allaboutcookies.org
          </a>
          . You may also be able to configure your browser not to accept
          cookies, although please bear in mind that this may affect your
          ability to use the services we provide.
        </p>
        <h2>CHANGES TO OUR PRIVACY NOTICE</h2>
        <p>
          Any changes we may make to our privacy policy in the future will be
          posted on this page and, where appropriate, notified to you by e-mail.
          Please check back frequently to see any updates or changes to our
          privacy notice.
        </p>
        <h2>CONTACT US</h2>
        <p>
          All comments, queries and requests relating to our use of your
          information are welcomed, or if you should wish to exercise any of
          your rights, you should write to the address below, marked FAO
          Corporate Legal
        </p>
        <p>Hammer Price Homes Limited, 102 Chapel Lane, Wigan, WN3 4HG</p>
      </TextContent>
    </div>
  </Layout>
);

export default asPage(TermsOfUse);
